import { FC } from "react";

import { CHEVRON_RIGHT_ICON_PATHS } from "mds/utils/icon-paths";
import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChevronRightIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path d={CHEVRON_RIGHT_ICON_PATHS[0]} fill="currentColor" />
  </svg>
);
